module.exports = __webpack_public_path__ + "static/img/kefu.668f752c.png";